import template from './header.html'
import css from './header.css'
import { HeaderController } from './header.controller.js'

export const HeaderComponent = {
  template: template,
  controller: HeaderController,
  controllerAs: 'HeaderController',
  bindings: {
    title: '<'
  },
  require:{
parentSimulator: '^^simulatorComponent'
	}
}


/*
Component Bindings :

1. '=' Two-way data binding. This means that if you update that variable in your component scope, the change will be reflected on the parent scope;

2. '<' One-way bindings when we just want to read a value from a parent scope and not update it;

3. '@' This is for string parameters;

4. '&' This is for callbacks in case your component needs to output something to its parent scope.

*/



// WEBPACK FOOTER //
// ./src/client/common/uiComponents/Header/header.component.js